exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.circle {\r\n  width: 7px;\r\n  /* 圆圈的宽度 */\r\n  height: 7px;\r\n  /* 圆圈的高度 */\r\n  border: 1.5px solid;\r\n  /* 边框的宽度 */\r\n  border-radius: 50%;\r\n  /* 圆的半径 */\r\n  border-color: #671E75;\r\n  /* 边框颜色 */\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  /* 确保宽度和高度包括边框 */\r\n  display: inline-block;\r\n  margin-right: 5px;\n}\n.solid-circle {\r\n  width: 7px;\r\n  /* 圆圈的宽度 */\r\n  height: 7px;\r\n  /* 圆圈的高度 */\r\n  border-radius: 50%;\r\n  /* 圆的半径 */\r\n  background-color: #671E75;\r\n  /* 边框颜色 */\r\n  display: inline-block;\r\n  margin-right: 5px;\n}\r\n", ""]);

// exports
